import { Chip } from "primereact/chip";
import { useAppSelector } from "../../hooks/storeHooks";
import { selectPhotoFolders } from "../../store/selectors/inspectionSelectors";
import { getPhotoFolderValues } from "../../utils/imageHelper";
import { Button } from "primereact/button";
import { classNames } from "primereact/utils";

type Props = {
    folders: string | null;
    enabled: string | null;
    setEnabled: (enabled: string) => void;
};

export const ImageFolderChips = (props: Props) => {
    const { folders, enabled, setEnabled } = props;

    const photoFolders = useAppSelector(selectPhotoFolders);

    if (!folders) {
        return null;
    }

    const photoFolderValues = getPhotoFolderValues(photoFolders, folders);

    const onClick = (photoFolderId: number) => () => {
        const enabledSplit = enabled?.split(";") ?? [];
        const id = photoFolderId.toString();

        if (enabled?.includes(id)) {
            setEnabled(
                enabledSplit.filter((folder) => folder !== id).join(";")
            );
        } else {
            setEnabled(enabledSplit.concat([id]).join(";"));
        }
    };

    return (
        <div className="flex gap-3 mt-3">
            {photoFolderValues.map((photoFolderValue) => (
                <Chip
                    key={photoFolderValue.Id}
                    className={classNames("image-chip", { "image-chip-enabled": enabled?.includes(photoFolderValue.Id.toString())})}
                    label={photoFolderValue.Name}
                    onClick={onClick(photoFolderValue.Id)}
                />
            ))}
        </div>
    );
};
